export const validColors = ['blue', 'beige', 'green'] as const

export type ValidColor = (typeof validColors)[number]

export type CardType = {
  imageUrl: string
  title?: string
  description?: string
  url?: string
  linkText?: string
  extras?: {
    color?: ValidColor
    margin_type?: 'category_hero' | 'small' | 'medium' | 'large' | 'none'
    image_position?: 'left' | 'center' | 'right' | 'top' | 'bottom'
    terms_id?: string
  }
}

export type ContentCardBannerProps = {
  className?: string
  cards?: CardType[]
}
